import React from 'react';
import T from 'prop-types';

export const Header = ({ leftItem, rightItem }) => {
    return <div className="headerSec">
        <div className="leftSec">{leftItem}</div>
        <div className="rightSec">{rightItem}</div>
    </div>;
};

Header.T = {
    leftItem: T.string,
    rightItem: T.string,
};
